export const PERIOD_SET = 'PERIOD_SET'
export const RUN_SET = 'RUN_SET'
export const RUN_INITIALIZE = 'RUN_INITIALIZE'
export const RUN_INITIALIZE_ERROR = 'RUN_INITIALIZE_ERROR'
export const RUN_LOADING = 'RUN_LOADING'
export const RUN_CLEAN = 'RUN_CLEAN'
export const RUN_ERROR = 'RUN_ERROR'
